var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "currentColor",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.086 2.5a2 2 0 0 1 1.284.467l.13.119L20.914 7.5a2 2 0 0 1 .578 1.238l.008.176V20.5a2 2 0 0 1-1.85 1.995l-.15.005h-6v-2h6v-10H15a1.5 1.5 0 0 1-1.493-1.356L13.5 9V4.5h-6v8h-2v-8a2 2 0 0 1 1.85-1.995L7.5 2.5h7.586ZM9.207 14.964l2.829 2.829a1 1 0 0 1 0 1.414l-2.829 2.828a1.002 1.002 0 0 1-1.72-.704 1 1 0 0 1 .306-.71L8.914 19.5H4.5a1 1 0 0 1 0-2h4.414l-1.121-1.121a1 1 0 0 1 1.414-1.415ZM15.5 4.914V8.5h3.586L15.5 4.914Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.023b48d64b35ee3662103cdf29edf3c4.svg";
export { ForwardRef as ReactComponent };